const moduleMargins = {
    md: ['16px', null, '24px'],
};

export default moduleMargins;
